export default {
  terms: '/terms',
  privacy: '/privacy',
  verifyEmail: '/verify-email/:token',
  externalVerification: '/verify-external/:token',
  kitCta: '/kit-cta/:uuid',
  kitsUnsubscribe: '/kits-unsubscribe/:uuid',
};
